import { Component, inject } from '@angular/core';
import { LevelService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  LevelCreateDto,
  LevelDto,
  LevelExcelDownloadDto,
  LevelUpdateDto,
} from '../proxy/controlling/dtos/level';
import { LEVEL_CONFIG, LEVEL_FIELDS } from './level.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-level',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, LevelService, ConfirmationService],
  templateUrl: './level.html',
  styleUrl: './level.scss',
})
export class Level extends BaseCrudComponent<
  LevelDto,
  LevelCreateDto,
  LevelUpdateDto,
  LevelExcelDownloadDto
> {
  service = inject(LevelService);
  config = LEVEL_CONFIG;
  fields = LEVEL_FIELDS;

  protected prepareUpdateDto(data: any, selected: LevelDto): LevelUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Level';
  }
}
